import React, { useState } from "react";
import "./newtaskboard.css";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import SprintTabelBox from "./tabelBox/SprintTabelBox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const TaskBoardColumn = ({ mileStoneName, sprints, index }) => {
  const [sprintsStatus, setSprintStatus] = useState(false);

  const handleClickMileStone = () => {
    setSprintStatus(!sprintsStatus);
  };
  return (
    <>
      <div className="taskboardColumn">
        <div className="mileStone-head">
          {sprintsStatus ? <ArrowDropDownIcon /> : <ArrowRightIcon />}

          <h3 onClick={() => handleClickMileStone()}>{mileStoneName}</h3>
        </div>
        <div></div>
      </div>
      {sprintsStatus &&
        sprints?.map((sprntsval, sprintIndex) => (
          <SprintTabelBox
            mileStoneName={mileStoneName}
            sprintsvalue={sprntsval}
            milestoneIndex={index}
            sprintIndex={sprintIndex}
            key={sprintIndex}
          />
        ))}
    </>
  );
};

export default TaskBoardColumn;
